import React, { useContext, useEffect, useState } from "react";
import AboutUsBanner from "./aboutUsBanner";
import historyBG from "../../assets/images/historyBG.png";
import "../../assets/css/--page-aboutus.css";
import history1982 from "../../assets/images/1982.png";
import history from "../../assets/images/history.png";

export default function MenuPage() {

  return (
    <div className="history-section">
        <img src={historyBG} className="history-bg" alt="History illustration" />
        <div className="history-layout">
            <div className="wrapper">
                <div className="header">
                    <h1>ROOTED IN TRADITION, SERVING WITH HEART SINCE <span className="year-since-img"><img src={history1982} /></span></h1>
                    <p>Serving hot meals, groceries, and hometown warmth — all under one roof.</p>
                </div>
                    <div className="separator" />
                <div className="content-section">
                    <div className="content">
                        <h2>For over four decades, Main’s Country Store & Grill
                        has been more than just a local business—it’s been the beating heart of our community. </h2>
                        <p>
                        Founded in 1982 by Thomas and Carol Main, Main’s has proudly stood as a local landmark for generations of families, commuters, and hard-working folks in town. In 2020, the legacy continued when ownership passed to their daughter and grandson—Tracy Gordon and myself—ensuring that Main’s stayed in the family and remained true to its roots. 
                        </p>
                    </div>
                    <div className="history-img-container">
                        <img src={history} className="history-img"/>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>

  );
}
